module.exports = __webpack_public_path__ + "static/media/video1.2459e4e3.mp4";